export default "__VITE_ASSET__CjEjgVYU__"